import { useEffect } from 'react';

import ProjectCase from '@/components/project-case/ProjectCase';

import classes from './ProjectCasePage.module.scss';

const ProjectCasePage = () => {
	useEffect(() => {
		document.title = 'ERP - Project';
	}, []);

	return (
		<section className={classes.mainContainer}>
			<ProjectCase />
		</section>
	);
};

export default ProjectCasePage;
